export default [
  {
    path: '/chat/:employeeId',
    name: 'chat-customer',
    component: () => import('@/components/chat/chat.vue'),
    meta: {
      resource: 'customer',
      action: 'manage',
    },

  },
  {
    path: '/chat/:employeeId',
    name: 'chat-specialist',
    component: () => import('@/components/chat/chat.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },

  },
]
